import SearchInput from 'components/SearchInput'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('locations.location_list')

type Props = {
  value: string
  onChange: (next: string) => void
}

// Wraps the shared `SearchInput` to provide the localised placeholder
// and bottom-margin matching the rest of the page surface — the
// underlying component already handles the search icon + clear button
// + a11y label.
const SearchBar = ({ value, onChange }: Props) => (
  <div className="mb-m">
    <SearchInput
      value={value}
      onChange={onChange}
      placeholder={t('search_placeholder') as string}
    />
  </div>
)

export default SearchBar
